import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_boho_living: FaireThemeEntity = {
  token: "discovery_theme_boho-living",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Boho Living",
  description: "Free-spirited decor with eclectic flair",
  bgColor: "#E8D4C0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
